import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, Inject, PLATFORM_ID, NgZone, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { $ } from 'protractor';
import { isPlatformBrowser } from '@angular/common';

declare const google: any;


@Component({
  selector: 'app-ad2',
  templateUrl: './ad2.component.html',
  styleUrls: ['./ad2.component.css']
})
export class Ad2Component implements OnInit{

  @Output() stepChangeEvent = new EventEmitter<string>();

  @ViewChild('mapContainer', {static: false}) gmap: ElementRef;

  @ViewChild('location', {static: false}) location: ElementRef;

  map: google.maps.Map;

  coordinates: any

  mapOptions: google.maps.MapOptions

  marker: any

  longitude: string = '85.30328010000001'

  latitude: string = '27.6697302'

  autocomplete: any

  provinceList = []

  districtList = []

  municipalityList = []

  validMunicipalityList = []

  validDistrictList = []

  selectedUnitDistance: string ="Meter"

  secondAdForm: FormGroup = new FormGroup({ 
    province_id: new FormControl( null, [Validators.required]),
    district_id: new FormControl( null, [Validators.required]),
    wardNumber: new FormControl( null, [Validators.required]),
    village: new FormControl(''),
    distFromRoad: new FormControl(''),
    municipality_id: new FormControl(null, [Validators.required]),
    latitude: new FormControl(this.latitude, [Validators.required]),
    longitude: new FormControl(this.longitude, [Validators.required]),
  })

  options = {
    componentRestrictions: {country: 'np'}
  };

  constructor( private route: ActivatedRoute, @Inject(PLATFORM_ID) protected platformId: Object, private _ngZone: NgZone, private cdr: ChangeDetectorRef ) { }

  ngOnInit(): void {
    this.route.data.subscribe((data: { provinceList: any, districtList: any, municipalityList: any }) =>{
      this.provinceList = data.provinceList.provinces
      this.districtList = data.districtList.districts
      this.municipalityList = data.municipalityList.municipalities
    })
    this.validDistrictList = this.districtList
    this.validMunicipalityList = this.municipalityList
    this._ngZone.run(() => {
      setTimeout(() => {
        this.mapInitializer()
        this.cdr.detectChanges()
      }, 3000)
    })   
  }

  onProvinceSelected($event){
    this.validDistrictList = []
    for(let district of this.districtList){
      if(district.province_id == $event){
        this.validDistrictList.push(district)
      }
    }
  }

  onDistrictSelected($event){
    this.validMunicipalityList = []
    for(let muncipality of this.municipalityList){
      if(muncipality.district_id == $event){
        this.validMunicipalityList.push(muncipality)
      }
    }
    let selectedDistrict = this.districtList.find(district => district.id == $event)
    if(selectedDistrict){
      this.secondAdForm['controls']['province_id'].setValue(selectedDistrict.province_id)
    }
  }

  onMunicipalitySelected($event){
    let selectedMunicipality = this.municipalityList.find(municipality => municipality.id == $event)
    if(selectedMunicipality){
      this.secondAdForm['controls']['district_id'].setValue(selectedMunicipality.district_id)
      let selectedDistrict = this.districtList.find(district => district.id == selectedMunicipality.district_id)
      if(selectedDistrict){
        this.secondAdForm['controls']['province_id'].setValue(selectedDistrict.province_id)
      }
    }
  }

  next(){
    this.secondAdForm['controls']['latitude'].setValue(this.latitude)
    this.secondAdForm['controls']['longitude'].setValue(this.longitude)
    this.stepChangeEvent.emit('step-3')
  }

  previous(){
    this.stepChangeEvent.emit('step-1')
  }

  mapInitializer() {
    if(isPlatformBrowser(this.platformId)){
      this.coordinates  = new google.maps.LatLng(this.latitude, this.longitude)
      this.mapOptions = {
          center: this.coordinates,
          zoom: 14
      }
      this.marker = new google.maps.Marker({
          position: this.coordinates,
          map: this.map,
      })
      this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions)
      this.autocomplete = new google.maps.places.Autocomplete(this.location.nativeElement, this.options);
      google.maps.event.addListener(this.autocomplete, 'place_changed', ()=>{
        var place = this.autocomplete.getPlace();
        if(this.marker === false){
          this.marker = new google.maps.Marker({
            position: place.geometry.location,
            map: this.map,
            draggable: true //make it draggable
          });
          this.map.setCenter(place.geometry.location);
        }else{
          this.marker.setPosition(place.geometry.location);
          this.map.setCenter(place.geometry.location);
        }
        this.latitude = this.marker.getPosition().lat()
        this.longitude = this.marker.getPosition().lng()
      });
      google.maps.event.addListener(this.map, 'click', (event)=> {
        var clickedLocation = event.latLng;
        if(this.marker === false){
          this.marker = new 
          google.maps.Marker({
            position: clickedLocation,
            map: this.map,
            draggable: true, //make it draggable
            title: "Your Location"
          });
          google.maps.event.addListener(this.marker, 'dragend', (event)=>{
            this.latitude = this.marker.getPosition().lat()
            this.longitude = this.marker.getPosition().lng()
          });
        }else{
          this.marker.setPosition(clickedLocation);
        }
        this.latitude = this.marker.getPosition().lat()
        this.longitude = this.marker.getPosition().lng()
      });
      google.maps.event.addListener(this.marker, 'dragend', (event) => {
        let draggedLocation = event.latLng;
        this.marker.setPosition(draggedLocation)
        this.latitude = this.marker.getPosition().lat()
        this.longitude = this.marker.getPosition().lng()
      })
      this.marker.setMap(this.map);
    }
  }

}